<template>
  <div v-html="html">
  </div>
</template>

<script>

// comunicacion HTTP con RestApi
import axios6 from "axios"

// constantes para todo el proyecto
import { escribirLog, generarUrlBase } from '@/plugins/utilidades.js'




export default {
  name: "PaginaAvisoLegal",

  data: () => ({
    html: '',
    tipoPagina: 0
  }),

  watch: {
    // captura el cambio de idioma
    '$i18n.locale': function (val) {
      this.obtenerTerminosCondiciones(val);
    },

    // captura los cambios de parametros en la ruta si le llama esta pagina estando activa
    $route: function() {
      this.obtenerTerminosCondiciones(this.$i18n.locale.toUpperCase());
      window.scrollTo(0,0);
    }
  },

  methods: {
    obtenerTerminosCondiciones: function(idioma) {
      escribirLog('Consulta ObtenerCondicionesLegales');

      escribirLog(this.$route.params);

      var parametros= {
        'idioma': idioma,
        'tipo_pagina': this.$route.params.tipoPagina
      };

      const cabeceras = {
      };

      axios6
        .get(generarUrlBase() + '/restapi/BD/obtenerCondicionesLegales', 
              { params: parametros,
                headers:cabeceras
              })
        .then(response => {
          escribirLog('Respuesta ObtenerCondicionesLegales');
          this.html = response.data.terminos.terminos.texto;
//          escribirLog(response.data.terminos.terminos.texto);
        })

      }  // fin ObtenerTerminosCondiciones


  },  // fin methods

  mounted () {
    // consulto al parking por el texto a presentar
    this.obtenerTerminosCondiciones(this.$i18n.locale.toUpperCase());
    window.scrollTo(0,0);

  },
   // fin evento mounted  

};
</script>
